/**
 * 后台返回的各种业务代码暂时就一个特殊处理
 *
 */

// 020108 去登录 token过期
const RC_LOGIN_OUT = 401
// token
const RC_TOKEN_ERR = '020103'
// 请求成功
const RC_SUCCESS = 0

// 渠道无法匹配
const RC_CHANNEL_ERR = 40041

// 推送律师人数
const RC_NOTIFICATIONS_NUMBER = '101'
// 接单律师
const RC_ORDER_LAWYER = '102'
// 咨询结束
const RC_ORDER_OVER = '103'

/**
 * NOT_LINK：6未接通
 *
 * @type {{NOT_LINK: number}}
 *
 *
 *
 * 1  用户点击“立即咨询”  未接单
 5  律师点了接单之后  受理中
 6  呼叫律师，律师未接  律师端未接通
 7  律师接起，律师挂机  律师端已挂机
 8  律师接起，用户未接  用户端未接通
 3  已支付，待评价  待评价
 2：待支付
 */
const ORDER_STATUE = {
  START: 1,
  UNPAY: 2,
  APPRAISE: 3,
  NOT_LINK: 6
}

/**
 * 支付成功
 * @type {string}
 */
const RC_PAY_SUCCESS = '301'

export const code = {
  RC_SUCCESS,
  RC_CHANNEL_ERR,
  RC_LOGIN_OUT,
  RC_PAY_SUCCESS,
  RC_TOKEN_ERR,
  RC_NOTIFICATIONS_NUMBER,
  RC_ORDER_LAWYER,
  RC_ORDER_OVER,
  ORDER_STATUE
}

export default code



// WEBPACK FOOTER //
// ./src/libs/request/result-code.js